import {
    useMutation,
    useQuery,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query'
import {
    fetchVessels,
    lookupOtsmOnlyVessel,
    validateOtsmOnlyVessels,
} from '../../api/vessels/vessels'
import {type OtsmVesselRequest} from '../../api/vessels/types/vessels.types'
import {AxiosError, type AxiosRequestConfig} from 'axios'

const queryKeys = {
    vessels: 'vessels',
}

// Using this causes 1 extra API call as we currently
// have redux thunk that also fetches vessels. Refactoring all
// components that depends on the redux state is a whole lot of
// work by itself.
type FetchVesselsParams = Parameters<typeof fetchVessels>[0]

export function useQueryVessels(
    params: FetchVesselsParams = {},
    options?: UseQueryOptions<Awaited<ReturnType<typeof fetchVessels>>, AxiosError>,
): UseQueryResult<Awaited<ReturnType<typeof fetchVessels>>, AxiosError> {
    return useQuery({
        retry: false,
        queryKey: [queryKeys.vessels, params],
        queryFn: () => fetchVessels(params),
        ...options,
    })
}
export function useValidateOtsmVesselMutation() {
    return useMutation({
        mutationFn: async (data: {
            vesselsInfo: OtsmVesselRequest[]
            config?: AxiosRequestConfig
        }) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return await validateOtsmOnlyVessels(data.vesselsInfo, data.config)
        },
    })
}

export function useLookupOtsmVesselMutation() {
    return useMutation({
        mutationFn: async (data: {imos: string[]; config?: AxiosRequestConfig}) => {
            return await lookupOtsmOnlyVessel(data.imos, data.config)
        },
    })
}
